const basePath = "/manual/matpower/";

export const HTMLPaths = {
  manualPath: basePath + "MATPOWER.html",

  busdataTablePath: basePath + "DataFileFormat.html#tab:busdata",

  loadsPath: basePath + "Loads.html",
  shuntElementsPath: basePath + "ShuntElements.html",

  generatorsPath: basePath + "Generators.html",
  gendataTablePath: basePath + "DataFileFormat.html#tab:gendata",

  branchesPath: basePath + "Branches.html",
  branchdataTablePath: basePath + "DataFileFormat.html#tab:branchdata",

  dclinesPath: basePath + "ExampleExtensions.html#sec:dclines",
  dclinedataTablePath: basePath + "DataFileFormat.html#tab:dclinedata",

  runpfPath: basePath + "ttrunpf.html",
  pfoptionsTablePath: basePath + "ttrunpf.html#tab:pfoptions",
  pfresultsTablePath: basePath + "ttrunpf.html#tab:pfresults",
  dcModelingPath: basePath + "DCModeling.html",
  voltageRepresentationPath: basePath + "ACPowerFlow.html#x51-370004.1.1",
  balanceEquationsPath: basePath + "ACPowerFlow.html#x51-380004.1.2",

  opfVoltagePath: basePath + "StandardACOPF.html#x69-590006.1.1",
  opfBalanceEquationsPath: basePath + "StandardACOPF.html#x69-600006.1.2",

  runopfPath: basePath + "ttrunopf.html",
  opfoptionsTablePath: basePath + "ttrunopf.html#tab:opfoptions",
  opfresultsTablePath: basePath + "ttrunopf.html#tab:opfresults"
};

// const pdfPath = "https://matpower.org/docs/MATPOWER-manual.pdf";
export const pdfPath = "/manual/MATPOWER-manual.pdf";

export const PDFPaths = {
  manualPath: pdfPath,

  busdataTablePath: pdfPath + "#page=150",

  loadsPath: pdfPath + "#subsection.3.4",
  shuntElementsPath: pdfPath + "#subsection.3.5",

  generatorsPath: pdfPath + "#subsection.3.3",
  gendataTablePath: pdfPath + "#page=151",

  branchesPath: pdfPath + "#subsection.3.2",
  branchdataTablePath: pdfPath + "#page=152",

  dclinesPath: pdfPath + "#subsubsection.7.6.3",
  dclinedataTablePath: pdfPath + "#page=154",

  runpfPath: pdfPath + "#subsection.4.4",
  pfoptionsTablePath: pdfPath + "#page=46",
  pfresultsTablePath: pdfPath + "#page=44",
  dcModelingPath: pdfPath + "#subsection.3.7",
  voltageRepresentationPath: pdfPath + "#subsubsection.4.1.1",
  balanceEquationsPath: pdfPath + "#subsubsection.4.1.2",

  opfVoltagePath: pdfPath + "#subsubsection.6.1.1",
  opfBalanceEquationsPath: pdfPath + "#subsubsection.6.1.2",

  runopfPath: pdfPath + "#subsection.6.6",
  opfoptionsTablePath: pdfPath + "#page=78",
  opfresultsTablePath: pdfPath + "#page=76"
};
